import React from "react";
import { Search } from "lucide-react";
import CustomDropdown from "../common/CustomDropdown";

const PRODUCT_SORT_OPTIONS = [
    { value: "newest", label: "Newest first" },
    { value: "oldest", label: "Oldest first" },
];

const ProductFilters = ({
    searchValue,
    sortValue,
    onSearchChange,
    onSortChange,
    autoFocus = false,
}) => {
    return (
        <div className="grid w-full min-w-0 grid-cols-[minmax(0,1fr)_9.5rem] gap-3">
            <label className="relative block min-w-0">
                <span className="sr-only">Search products</span>
                <Search
                    size={15}
                    className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                    aria-hidden="true"
                />
                <input
                    type="search"
                    value={searchValue}
                    autoFocus={autoFocus}
                    onChange={(event) => onSearchChange?.(event.target.value)}
                    placeholder="Search products..."
                    className="h-11 w-full min-w-0 rounded-xl border border-slate-200 bg-white pl-9 pr-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                />
            </label>

            <CustomDropdown
                id="product-sort-filter"
                value={sortValue}
                options={PRODUCT_SORT_OPTIONS}
                onChange={onSortChange}
                ariaLabel="Sort products by creation date"
                className="min-w-0"
                buttonClassName="h-11"
            />
        </div>
    );
};

export default ProductFilters;
